import { PAGE_PATH, PROGRAM_TRAIL_PATH } from '../constants'
import { SCREENING_TOKEN_KEY } from '@cannect/services/resources/screening/requests'

export const PROGRAM_TRAIL_SEARCH_KEY = '@CANNECT_PROGRAM_TRAIL_SEARCH'
export const TRAIL_STEP_QUERY = 'step'
export const TRAIL_SESSION_QUERY = 'session'

export const TRAIL_STEPS = [
  'escolha',
  'nome',
  'whatsapp',
  'nascimento',
  'menor',
  'medidas',
  'imc',
  'imc-fora',
  'seguranca',
  'perfil',
  'oferta',
  'agora-nao',
  'identificacao',
  'pagamento',
  'pagamento-erro',
  'pago',
  'agenda',
  'dados',
  'perguntas',
  'clinica',
  'enviado'
] as const

export type TTrailStep = (typeof TRAIL_STEPS)[number]

export const TRAIL_STEP_TOTAL = 19

export const rememberTrailSearch = (search: string) => {
  try {
    sessionStorage.setItem(PROGRAM_TRAIL_SEARCH_KEY, search)
  } catch {
    /* ignore */
  }
}

const searchParams = (search: string) => new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)

export const trailStepFromSearch = (search: string): TTrailStep | '' => {
  const step = searchParams(search).get(TRAIL_STEP_QUERY) || ''
  return TRAIL_STEPS.includes(step as TTrailStep) ? (step as TTrailStep) : step ? 'escolha' : ''
}

export const isTrailOpenSearch = (search: string) => searchParams(search).has(TRAIL_STEP_QUERY)

export const mergeTrailSearch = (search: string, token?: string, step?: TTrailStep | '') => {
  const params = searchParams(search)
  if (token) params.set(TRAIL_SESSION_QUERY, token)
  else if (step === 'escolha') params.delete(TRAIL_SESSION_QUERY)
  if (step) params.set(TRAIL_STEP_QUERY, step)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export const buildTrailPath = (step: TTrailStep | '', token?: string, search = '') =>
  `${PROGRAM_TRAIL_PATH}${mergeTrailSearch(search, token, step || 'escolha')}`

export const legacyTrailLocation = (step: string | undefined, search: string) =>
  buildTrailPath(
    TRAIL_STEPS.includes(step as TTrailStep) ? (step as TTrailStep) : 'escolha',
    new URLSearchParams(search).get(TRAIL_SESSION_QUERY) || undefined,
    search
  )

export const closeTrailPath = (search = '') => {
  const params = searchParams(search)
  params.delete(TRAIL_STEP_QUERY)
  params.delete(TRAIL_SESSION_QUERY)
  params.delete('cart_id')
  const qs = params.toString()
  return `${PAGE_PATH}${qs ? `?${qs}` : ''}`
}

export const storedTrailSearch = () => {
  try {
    return sessionStorage.getItem(PROGRAM_TRAIL_SEARCH_KEY) || ''
  } catch {
    return ''
  }
}

export const storedScreeningToken = () => {
  try {
    return sessionStorage.getItem(SCREENING_TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export const persistScreeningToken = (token: string) => {
  try {
    sessionStorage.setItem(SCREENING_TOKEN_KEY, token)
  } catch {
    /* ignore */
  }
}

const SCHEDULED_LABEL_KEY = 'wlp_scheduled_label'

// A tela final cita a data da consulta; o horário escolhido só existe em memória, então fica guardado para o reload.
export const persistScheduledLabel = (label: string) => {
  try {
    sessionStorage.setItem(SCHEDULED_LABEL_KEY, label)
  } catch {
    /* a tela final só omite a data */
  }
}

export const storedScheduledLabel = () => {
  try {
    return sessionStorage.getItem(SCHEDULED_LABEL_KEY) || ''
  } catch {
    return ''
  }
}
